__turbopack_context__.v({
  "layoutChildrenContainer": "layoutTemplate-module-scss-module__jA2HmG__layoutChildrenContainer",
  "pageContainerWithStickyFooter": "layoutTemplate-module-scss-module__jA2HmG__pageContainerWithStickyFooter",
  "topSticky": "layoutTemplate-module-scss-module__jA2HmG__topSticky",
});
